const de = {
  Rezepte: 'Rezepte',
  Zeitkapsel: 'Zeitkapsel',
  Musik: 'Musik',
  Listen: 'Listen',
  Einstellungen: 'Einstellungen',
  Theme: 'Theme',
  Sprache: 'Sprache',
  Hell: 'Hell',
  Dunkel: 'Dunkel',
  System: 'System',
  Deutsch: 'Deutsch',
  Englisch: 'Englisch',
  Schließen: 'Schließen',
  Chats: 'Chats',
  'Deine Listen': 'Deine Listen',
  Willkommen: 'Willkommen bei Alicas Zeitkapsel',
  LoginText: 'Bitte logge dich ein oder registriere dich, um fortzufahren.',
  NochKeinAccount: 'Noch keinen Account? Jetzt registrieren',
  ZurueckZumLogin: 'Zurück zum Login',
  Wordle: 'Wordle',
  WordleDesc: 'Rate das Wort in 6 Versuchen',
  NeuesSpiel: 'Neues Spiel',
  Ueberpruefen: 'Überprüfen',
  WordleHint: 'Tippe Buchstaben ein und drücke Enter zum Raten',
  WaehleDeinSpiel: 'Wähle dein Spiel',
  NeueErinnerung: 'Neue Erinnerung hinzufügen',
  NachrichtFuerZukunft: 'Schreibe eine Nachricht für die Zukunft...',
  BildHochladen: 'Bild hochladen',
  Vorschau: 'Vorschau',
  Abbrechen: 'Abbrechen',
  Speichern: 'Speichern',
  FehlerLaden: 'Fehler beim Laden der Erinnerungen',
  FehlerSpeichern: 'Fehler beim Speichern',
  ErinnerungErfolg: 'Erinnerung erfolgreich gespeichert!',
  BitteTextOderBild: 'Bitte Text und/oder Bild hinzufügen.',
  GepostetVon: 'Gepostet von',
  Unbekannt: 'Unbekannt',
  MemoryBildAlt: 'Bild',
  VorschauBildAlt: 'Vorschau',
  Datum: 'Datum',
  Erinnerungen: 'Erinnerungen',
  Hinzufuegen: 'Hinzufügen',
  Bild: 'Bild',
  Text: 'Text',
  LadeErinnerungen: 'Lade Erinnerungen...',
  NeuenSongPosten: 'Neuen Song posten',
  SpotifyLinkOderSongname: 'Spotify-Link oder Songname',
  Suchen: 'Suchen',
  KeinSongGefunden: 'Kein Song gefunden!',
  FehlerSpotifySuche: 'Fehler bei der Spotify-Suche.',
  SongErfolgGepostet: 'Song erfolgreich gepostet!',
  AufSpotifyOeffnen: 'Auf Spotify öffnen',
  Preview: 'Preview',
  DeinBrowserUnterstuetztKeinAudio: 'Dein Browser unterstützt kein Audio.',
  SongPosten: 'Song posten',
  OffeneChatAnfragen: 'Offene Chat-Anfragen',
  Von: 'Von',
  Annehmen: 'Annehmen',
  Ablehnen: 'Ablehnen',
  DeineChats: 'Deine Chats',
  NeuenChatStarten: 'Neuen Chat starten',
  UsernameSuchen: 'Username suchen',
  ChatAnfrageSenden: 'Chat-Anfrage senden',
  ChatMit: 'Chat mit',
  NachrichtSchreiben: 'Nachricht schreiben...',
  Senden: 'Senden',
  Entfernen: 'Entfernen',
  WaehleChatOderStarteNeuen: 'Wähle einen Chat aus oder starte einen neuen!',
  Du: 'Du',
  KeinUserGefunden: 'Kein User gefunden!',
  DuKannstDichNichtSelbstSuchen: 'Du kannst dich nicht selbst suchen!',
  EsExistiertBereitsEinChat: 'Es existiert bereits ein Chat oder eine Anfrage!',
  FehlerBeimSendenDerAnfrage: 'Fehler beim Senden der Anfrage!',
  AnfrageGesendet: 'Anfrage gesendet!',
  DeineListen: 'Deine Listen',
  NeueListeErstellen: 'Neue Liste erstellen',
  NameDerListe: 'Name der Liste',
  Erstellen: 'Erstellen',
  Einladungen: 'Einladungen',
  EinladungZu: 'Einladung zu',
  Liste: 'Liste',
  NeuerPunkt: 'Neuer Punkt',
  MitgliederVerwalten: 'Mitglieder verwalten',
  Mitglieder: 'Mitglieder',
  Ersteller: 'Ersteller',
  Mitglied: 'Mitglied',
  MitgliedDarfEinladen: 'Mitglied (darf einladen)',
  MitgliedEntfernen: 'Mitglied entfernen',
  DasIstDerErsteller: 'Das ist der Ersteller der Liste.',
  NeuesMitgliedEinladen: 'Neues Mitglied einladen',
  Username: 'Username',
  Einladen: 'Einladen',
  UserNichtGefunden: 'User nicht gefunden!',
  UserBereitsMitglied: 'User ist bereits eingeladen oder Mitglied!',
  EinladungVerschickt: 'Einladung verschickt!',
  ListeLoeschen: 'Liste löschen',
  Schliessen: 'Schließen',
  MitgliedVerwalten: 'Mitglied verwalten',
  DarfMitgliederEinladen: 'Darf Mitglieder einladen',
  Speichern: 'Speichern',
  RezepteDurchsuchen: 'Rezepte durchsuchen...',
  Kategorie: 'Kategorie',
  Alle: 'Alle',
  NeuesRezeptErstellen: 'Neues Rezept erstellen',
  Titel: 'Titel',
  Beschreibung: 'Beschreibung',
  Zubereitungszeit: 'Zubereitungszeit (Minuten)',
  Kochzeit: 'Kochzeit (Minuten)',
  Portionen: 'Portionen',
  Schwierigkeitsgrad: 'Schwierigkeitsgrad',
  Einfach: 'Einfach',
  Mittel: 'Mittel',
  Schwer: 'Schwer',
  Zutaten: 'Zutaten',
  Zutat: 'Zutat',
  Menge: 'Menge',
  Einheit: 'Einheit',
  ZutatHinzufuegen: 'Zutat hinzufügen',
  Zubereitungsschritte: 'Zubereitungsschritte',
  SchrittHinzufuegen: 'Schritt hinzufügen',
  Kategorien: 'Kategorien',
  Titelbild: 'Titelbild',
  BildURL: 'Bild-URL',
  TitelbildVorschau: 'Titelbild Vorschau',
  RezeptErstellen: 'Rezept erstellen',
  RezeptErfolg: 'Rezept erfolgreich erstellt!',
  FehlerRezept: 'Fehler beim Erstellen des Rezepts',
  Min: 'Min.',
  PortionenText: 'Portionen',
  BildURLOptional: 'Bild-URL (optional)',
  Schritt: 'Schritt',
  Kommentar: 'Kommentar',
  RezeptLiken: 'Rezept liken',
  RezeptEntfernenLike: 'Like entfernen',
  KommentarOeffnen: 'Kommentare anzeigen',
  RezeptErstellenBtn: 'Rezept erstellen',
  FehlerLadenRezepte: 'Fehler beim Laden der Rezepte',
  FehlerLadenKategorien: 'Fehler beim Laden der Kategorien',
  Kommentare: 'Kommentare',
  NochKeineKommentare: 'Noch keine Kommentare.',
  KommentarSchreiben: 'Kommentar schreiben...',
  SpeichernLaden: 'Speichern...',
  Kommentieren: 'Kommentieren',
  KommentarGespeichert: 'Kommentar gespeichert!',
  FehlerKommentar: 'Fehler beim Speichern des Kommentars',
  KommentarHinzufuegen: 'Kommentar hinzufügen',
  KommentarLoeschen: 'Kommentar löschen',
  Kommentarbild: 'Kommentarbild',
  KommentarbildAlt: 'Kommentarbild',
  KommentarZeit: 'am',
  RezeptNichtGefunden: 'Rezept nicht gefunden.',
  Zurueck: 'Zurück',
  Bearbeiten: 'Bearbeiten',
  Loeschen: 'Löschen',
  ZubereitungMin: 'Zubereitung (Min.)',
  KochzeitMin: 'Kochzeit (Min.)',
  Schwierigkeit: 'Schwierigkeitsgrad',
  ErstelltVon: 'Erstellt von',
  RezeptLoeschen: 'Rezept löschen',
  RezeptLoeschenBestaetigung: 'Möchtest du dieses Rezept wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
  RezeptLoeschenWarnung: 'Rezept löschen',
  RezeptAktualisiert: 'Rezept erfolgreich aktualisiert!',
  FehlerAktualisieren: 'Fehler beim Aktualisieren des Rezepts',
  FehlerLoeschen: 'Fehler beim Löschen des Rezepts',
  Avatar: 'Avatar',
  Menge: 'Menge',
  Zutat: 'Zutat',
  KunstwerkDesTages: 'Kunstwerk des Tages',
  MotivationDesTages: 'Motivation des Tages',
  FunFactDesTages: 'Fun Fact des Tages',
  FehlerLadenInspiration: 'Fehler beim Laden der Inspiration',
  Kunstwerk: 'Kunstwerk',
  Künstler: 'Künstler',
  Zitat: 'Zitat',
  ZitatAutor: 'Autor',
  FunFact: 'Fun Fact',
  BildAlt: 'Kunstwerk',
  BildOeffnen: 'Bild öffnen',
  InspirationDesTages: 'Inspiration des Tages',
  Datenschutzerklaerung: 'Datenschutzerklärung',
  DatenschutzUebersicht: '1. Datenschutz auf einen Blick',
  AllgemeineHinweise: 'Allgemeine Hinweise',
  DatenschutzAllgemeinText: 'Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen.',
  Datenerfassung: '2. Datenerfassung auf dieser Website',
  Verantwortlicher: 'Wer ist verantwortlich für die Datenerfassung auf dieser Website?',
  VerantwortlicherText: 'Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.',
  WelcheDaten: '3. Welche Daten werden erfasst?',
  WelcheDatenText: 'Auf dieser Website werden folgende personenbezogene Daten erfasst:',
  WelcheDatenListe: 'E-Mail-Adresse (für Login/Registrierung); Profilbild (optional); Benutzername; Zeitkapsel-Einträge (Nachrichten, Bilder, Videos); Chat-Nachrichten; Spielstand-Daten',
  Datenverarbeitung: '4. Wie werden Ihre Daten verarbeitet?',
  DatenverarbeitungText: 'Wir verwenden Supabase als Datenbankdienst. Die Datenschutzerklärung von Supabase finden Sie unter:',
  Rechte: '5. Ihre Rechte',
  RechteText: 'Sie haben jederzeit das Recht:',
  RechteListe: 'Auskunft über Ihre gespeicherten Daten zu erhalten; Diese berichtigen zu lassen; Die Löschung zu verlangen; Die Verarbeitung einzuschränken; Der Verarbeitung zu widersprechen; Ihre Daten in einem strukturierten Format zu erhalten',
  Speicherdauer: '6. Speicherdauer',
  SpeicherdauerText: 'Ihre Daten werden so lange gespeichert, wie es für die genannten Zwecke erforderlich ist. Sie können Ihr Konto jederzeit löschen, wodurch alle Ihre personenbezogenen Daten gelöscht werden.',
  Cookies: '7. Cookies',
  CookiesText: 'Diese Website verwendet nur technisch notwendige Cookies für die Funktionalität der Website. Es werden keine Tracking-Cookies oder Cookies von Drittanbietern verwendet.',
  Zurueck: 'Zurück',
  Impressum: 'Impressum',
  AngabenGemaess: 'Angaben gemäß § 5 TMG',
  Kontakt: 'Kontakt',
  VerantwortlichInhalt: 'Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV',
  EUStreitschlichtung: 'EU-Streitschlichtung',
  EUStreitschlichtungText: 'Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:',
  Verbraucherschlichtung: 'Verbraucherschlichtung',
  VerbraucherschlichtungText: 'Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.'
};
export default de; 